/**
 * @file index.js
 * @author Daniel Aguirre
 * @description Initialize DissentWithoutPsychologyAssessment View.
 */

// Commons
import {
  mapStateToProps,
  mapDispatchToProps
} from '@nephro/commons/mapReduxCRUD/index';

// Dependencies
import { connect } from 'react-redux';

// View
import View from './DissentWithoutPsychologyAssessmentView';

export const mapStateToPropsDissentWithoutPsychologyAssessment =
  mapStateToProps;
export const mapDispatchToPropsDissentWithoutPsychologyAssessment =
  mapDispatchToProps;

export default connect(
  mapStateToPropsDissentWithoutPsychologyAssessment,
  mapDispatchToPropsDissentWithoutPsychologyAssessment
)(View);
